export default __webpack_public_path__ + "static/media/groupsWhite.ccc4b1df.svg";